import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useState } from "react";
import { Monitoring } from "react-scan/monitoring/next";
export const ReactScanMonitoring = /*#__PURE__*/ memo(()=>{
    const [isClient, setIsClient] = useState(false);
    useEffect(()=>{
        setIsClient(true);
    }, []);
    if (!isClient) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Monitoring, {
        apiKey: "hTnbg251QUct_X3wVS3fvCB5R1HocXXF" // Safe to expose publically
        ,
        url: "https://monitoring.react-scan.com/api/v1/ingest",
        commit: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
        branch: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF
    });
});
ReactScanMonitoring.displayName = "ReactScanMonitoring";
export default ReactScanMonitoring;
